import React from 'react';
import { Link } from 'react-router-dom';
import '../styles/NavBar.css';  // Import the CSS file

const NavBar: React.FC = () => {
  return (
    <nav className="navbar">
      <div className="navbar-container">
        {/* Left-aligned brand name */}
        <Link className="navbar-brand" to="/">Monica Tang</Link>

        {/* Right-aligned navigation links */}
        <div className="navbar-links">
          <Link className="nav-link" to="/">Home</Link>
          <Link className="nav-link" to="/projects">Projects</Link>
        </div>
      </div>
    </nav>
  );
};

export default NavBar;
